import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { ModalConfig } from 'src/app/shared/components/modal/modal-config';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Reporte } from '../models/reporte';
import { ReportsService } from '../reports.service';
import { delay, take, finalize, concatMap, Observable, catchError, from, throwError } from 'rxjs';
import { TareaReporte } from 'src/app/features/tasks/tarea-reporte';
import { v4 as uuidv4 } from 'uuid';
import { REPORT_MESSAGES } from 'src/app/util/constantes-mensajes';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { DefaultRoutes, FeatureRoutes } from 'src/app/core/routes';
import { Roles } from 'src/app/features/user/user';
@Component({
    selector: 'app-report-item',
    templateUrl: './report-item.component.html',
    styleUrls: ['./report-item.component.scss'],
})
export class ReportItemComponent {
    // Report data that user select
    @Input() report: Reporte;
    // Property to emit an event when user removes a favorite report
    @Output() removeFavorite = new EventEmitter();
    //Config to set modal properties
    public modalConfig: ModalConfig;
    //Variable to show loader
    isLoading: boolean = false;
    hasPermission: boolean = false;
    faEllipsis = faEllipsis;

    constructor(private reportService: ReportsService, private modalService: ModalService, private authService: AuthService, private router: Router) {
        const { rol } = this.authService.user!;
        this.hasPermission = rol === Roles.admin || rol === Roles.specialist;
    }

    /**
     * A function that open the modal component or generate the report task
     * @returns {void}
     */
    loadData(): void {
        this.isLoading = true;
        this.reportService
            .getReportParameters(this.report.uuid)
            .pipe(
                take(1),
                delay(500),
                finalize(() => (this.isLoading = false)),
                concatMap((parameters) => {
                    this.report.parametros = parameters;
                    return parameters.length > 0 ? this.openModal() : this.generateTask();
                })
            )
            .subscribe({
                next: (response) => {
                    if (response) {
                        const message = response.message || REPORT_MESSAGES.GENERATE.REPORT;
                        const confirmTitle = response.confirmTitle || "Aceptar"
                        this.modalService.getConfirmacionModal({ message, confirmTitle, isError: response.isError }).result.then(() => {
                            this.router.navigateByUrl(DefaultRoutes.tasks)
                        })
                    }
                },
                error: (error) => this.modalService.getConfirmacionModal({ message: error.error.message, confirmTitle: "Cerrar", isError: true }),
            });
    }

    get hasOpenModals(): boolean {
        return this.modalService.hasOpenModals();
    }

    /**
     * Validates the favorite property in the selected report and emits an event
     * @param {boolean} value
     */
    onFavorite(value: boolean): void {
        this.reportService.setFavorite(this.report.uuid).subscribe({
            next: () => {
                this.report.favorito = value;
                if (!this.report.favorito) {
                    this.removeFavorite.emit();
                }
            },
            error: () => this.modalService.getConfirmacionModal({ message: REPORT_MESSAGES.UPDATE.ERROR_FAVORITE, confirmTitle: "Cerrar", isError: true }),
        });
    }

    /**
    * A function that open the report parameters modal
    * @returns {Observable<any>}
    */
    openModal(): Observable<any> {
        const modal = this.modalService.getReportParametersModal(this.report).result.then();
        return from(modal).pipe(delay(500));
    }

    /**
    * A function that creates the task report
    * @returns {Observable<any>}
    */
    generateTask(): Observable<any> {
        const tareaReporte: TareaReporte = {
            uuid: uuidv4(),
            reporte: this.report.uuid,
            usuario: this.authService.user!.uuid,
            parametros: []
        };
        return this.reportService.generateReportTask(tareaReporte).pipe(
            catchError((error) => throwError(() => error))
        );
    }

    editReport() {
        this.router.navigateByUrl(`${DefaultRoutes.dataVisualization}${FeatureRoutes.reports}/edit-report/${this.report.uuid}`);
    }
}